export var TrackerEvent;
(function (TrackerEvent) {
    TrackerEvent["NETS_INIT"] = "NETS_INIT";
    TrackerEvent["NETS_PRE_SELECT"] = "NETS_PRE_SELECT";
    TrackerEvent["NETS_SELECT_PROVIDER"] = "NETS_SELECT_PROVIDER";
    TrackerEvent["NETS_NO_POPUP"] = "NETS_NO_POPUP";
    TrackerEvent["NETS_POPUP_CREATED"] = "NETS_POPUP_CREATED";
    TrackerEvent["NETS_POPUP_OPENED"] = "NETS_POPUP_OPENED";
    TrackerEvent["NETS_POPUP_OPENED_ABORT"] = "NETS_POPUP_OPENED_ABORT";
    TrackerEvent["NETS_IDENTIFYING"] = "NETS_IDENTIFYING";
    TrackerEvent["NETS_IDENTIFYING_ABORT"] = "NETS_IDENTIFYING_ABORT";
    TrackerEvent["NETS_FINALIZING"] = "NETS_FINALIZING";
    TrackerEvent["NETS_FINALIZING_ABORT"] = "NETS_FINALIZING_ABORT";
    TrackerEvent["NETS_NETS_ERROR"] = "NETS_NETS_ERROR";
    TrackerEvent["NETS_NETS_TIMED_OUT"] = "NETS_NETS_TIMED_OUT";
    TrackerEvent["NETS_NEED_CPR"] = "NETS_NEED_CPR";
    TrackerEvent["NETS_NOT_CUSTOMER"] = "NETS_NOT_CUSTOMER";
    TrackerEvent["NETS_DONE"] = "NETS_DONE";
    TrackerEvent["NETS_CONFIRM_DONE"] = "NETS_CONFIRM_DONE";
    TrackerEvent["NETS_CONFIRM_DONE_RESTART"] = "NETS_CONFIRM_DONE_RESTART";
    TrackerEvent["NETS_CONFIRM_DONE_COMPLETED"] = "NETS_CONFIRM_DONE_COMPLETED";
})(TrackerEvent || (TrackerEvent = {}));
